import axios from 'axios';
axios.defaults.withCredentials = true;
import { fetchToken } from '../fetchToken';
const API_URL = process.env.EMAILS_API_URL;
import { logError } from '../../taskpane/utils/request';

export const getEmail = async (emailId, objectApiName, skipRecords, ownerEmail) => {
  const token = await fetchToken();
  let url = API_URL + `emails/${emailId}?objectApiName=${objectApiName}${skipRecords ? '&skipRecords=true' : ''}`;
  if (ownerEmail) {
    url += `&ownerEmail=${encodeURIComponent(ownerEmail)}`;
  }
  const config = {
    method: 'GET',
    url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  // if we don't get an error looking up this email, we can assume it is saved to the table.
  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

export const getRecentlyViewed = async (objectApiName) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: API_URL + `recent?objectApiName=${objectApiName}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  // if we don't get an error looking up this email, we can assume it is saved to the table.
  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    return e;
  }
};

/**
 * Get attachments for an email
 * @param {string} id - email id
 * @param {string} ownerEmail - email address of the owner
 * @param {boolean} isDraft - whether the email is a draft
 * @param {string} backgroundJobId - optional background job id for tracking
 * @return {Promise} - attachments and emlHash
 */
export const getAttachments = async (id, ownerEmail, isDraft = true, backgroundJobId) => {
  const token = await fetchToken();
  let url = API_URL + 'emails/' + id + '/attachments' + `?isDraft=${isDraft}`;
  if (ownerEmail) {
    url += `&ownerEmail=${encodeURIComponent(ownerEmail)}`;
  }

  if (backgroundJobId) {
    url += `&backgroundJobId=${backgroundJobId}`;
  }
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  try {
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (e) {
    logError(e);
    throw new Error(e);
  }
};

export const saveEmail = async (id, body, ownerEmail) => {
  const token = await fetchToken();
  let url = API_URL + 'emails/' + id;
  if (ownerEmail) {
    url += `?ownerEmail=${encodeURIComponent(ownerEmail)}`;
  }
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  return axios.put(url, body, { headers });
};

export const removeSaveLocation = async (id, deleteThread, previousJobId, selectedRecordId, ownerEmail) => {
  const token = await fetchToken();
  let url = `${API_URL}emails/${id}?deleteThread=${deleteThread.toString()}${previousJobId ? `&previousJobId=${previousJobId}` : ''}${selectedRecordId ? `&recordId=${selectedRecordId}` : ''}`;
  if (ownerEmail) {
    url += `&ownerEmail=${encodeURIComponent(ownerEmail)}`;
  }
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
  try {
    return (await axios.delete(url, { headers })).data;
  } catch (error) {
    logError(error);
    throw new Error(error);
  }
};

export const getRemovalJobStatus = async (emailId, jobId, ownerEmail) => {
  const token = await fetchToken();
  let url = `${API_URL}emails/${emailId}/status/${jobId}`;
  if (ownerEmail) {
    url += `?ownerEmail=${encodeURIComponent(ownerEmail)}`;
  }
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  return await axios.get(url, { headers });
};

/**
 * Gets details of an email
 * @param {string} id - email id
 * @param {string} ownerEmail - email address of the owner
 * @return {Promise}
 */
export const getEmailDetails = async (id, ownerEmail) => {
  const token = await fetchToken();
  let url = `${API_URL}emails/${id}/details`;
  if (ownerEmail) {
    url += `?ownerEmail=${encodeURIComponent(ownerEmail)}`;
  }
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  return (await axios.get(url, { headers })).data;
};

export const emailActiveSearch = async (objectApiName, searchString) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}emails/search?objectApiName=${objectApiName}&query=${encodeURIComponent(searchString)}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    return e;
  }
};
